'use client';

import { c as _c } from "react/compiler-runtime";
type RefusalAlertProps = {
  message: string;
};
export function RefusalAlert(t0) {
  const $ = _c(2);
  const {
    message
  } = t0;
  let t1;
  if ($[0] !== message) {
    t1 = <p role="alert" className="rounded-lg border border-borderError bg-backgroundSecondary p-4 text-contentRed text-sm">{message}</p>;
    $[0] = message;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}